import { useNavigate } from 'react-router-dom';

import Header from "../components/Header";
import Footer from "../components/Footer";
import Onboarding1 from "../images/onboarding1.gif";

const OnboardingOne= () => {
  const navigate = useNavigate();
  return (
    <>
      <Header isFixedPosition={true} />

      <div style={{ backgroundColor: '#f1f1f1', minHeight: 'calc(100vh - 160px)' }}>
        <div className='container flex pt-4'>
          <div className='w-2/3 p-12 px-20'>
            <img src={Onboarding1} alt="1" />
          </div>

          <div className='w-1/3 flex flex-col justify-center'>
            <div className='bg-gray-500 rounded font-bold text-2xl text-white flex justify-center items-center w-12 h-12 mb-12'>1</div>
            <h1 className={`font-bold text-5xl mb-3`}>Explore REBEL</h1>
            <p className={`text-gray-500 mb-12`}>Click through the colours or shapes to explore those capabilities and competencies that relate to your experiences.</p>
            <button
              className='bg-black text-2xl w-52 text-white px-8 py-3 font-semibold rounded'
              onClick={() => navigate('/onboardingtwo')}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
export default OnboardingOne;
